define((require) => {
    "use strict";

    const $                       = require("jquery");
    const CharacterPropertiesView = require("ui/experience/widgets/CharacterPropertiesView.js");
    const template                = require("ui/experience/widgets/button/LabelCharacterPropertiesView.tpl");

    return CharacterPropertiesView.extend("LabelCharacterPropertiesView", {

        template,

        hide() {
            this.$el.find(".row").each((i, element) => {
                const $element = $(element);

                if (!$element.hasClass("font-size-box")) {
                    $element.addClass("hidden");
                }
            });
        },

        unhide() {
            this.$el.find(".row")
                .each((i, element) => $(element).removeClass("hidden"));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/button/LabelCharacterPropertiesView.js